import type { Pattern, PatternId, Slice, SliceRange } from "@midi-fantom-utils/midi-util";

export type SliceBarProps = {
  slices: ReadonlyArray<Slice>;
  patterns: ReadonlyMap<PatternId, Pattern>;
  onEdit?: (sliceId: string) => void;
  onDelete?: (sliceId: string) => void;
  /** Клик по срезу без паттерна → привязать (открыть PatternDialog). */
  onBind?: (slice: Slice) => void;
};

const formatRange = (range: SliceRange): string => {
  return `M${range.startMeasure}–M${range.endMeasure}, ch ${range.channel}`;
};

export const SliceBar = ({ slices, patterns, onEdit, onDelete, onBind }: SliceBarProps) => {
  if (slices.length === 0) {
    return (
      <div className="muted">
        Добавьте метки над таймлайном и нажмите «Подготовить срезы».
      </div>
    );
  }
  return (
    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {slices.map((s) => {
        const pat = s.patternId ? patterns.get(s.patternId) : null;
        return (
          <li
            key={s.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "6px 0",
              borderBottom: "1px solid var(--border)",
            }}
          >
            <button
              type="button"
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: 8,
                border: "none",
                background: "transparent",
                color: "inherit",
                font: "inherit",
                textAlign: "left",
                cursor: pat ? "default" : "pointer",
                padding: 0,
              }}
              onClick={() => {
                if (!pat && onBind) onBind(s);
              }}
            >
              <span style={{ fontFamily: "ui-monospace, monospace", fontSize: 12 }}>
                {formatRange(s.range)}
              </span>
              {pat ? (
                <span style={{ flex: 1 }}>{pat.name}</span>
              ) : (
                <span className="muted">— без паттерна, нажмите, чтобы создать —</span>
              )}
            </button>
            {pat && onEdit ? (
              <button
                type="button"
                className="btn"
                onClick={() => onEdit(s.id)}
                aria-label="Редактировать паттерн"
              >
                ✎
              </button>
            ) : null}
            <button
              type="button"
              className="btn btn--ghost"
              onClick={() => onDelete?.(s.id)}
              aria-label="Удалить срез"
            >
              🗑
            </button>
          </li>
        );
      })}
    </ul>
  );
};
